import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import katibuLogo from '../../assets/katibu-logo.png';
import { setLogoutReason } from '../../services/sessionManager';

const isSuperAdmin = () => {
  try {
    if (localStorage.getItem('is_superadmin') === 'true') return true;
    return !!JSON.parse(localStorage.getItem('user') || '{}').is_superadmin;
  } catch { return false; }
};

const I = (path) => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
    strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
    style={{ flexShrink: 0, opacity: 0.75 }}>
    {path}
  </svg>
);

const S = (path) => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
    strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="sidebar-icon">
    {path}
  </svg>
);

const SECTIONS = [
  {
    id: 'lead',
    label: 'Lead Management',
    icon: S(<><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></>),
    items: [
      { label: 'Contacts',      to: '/contact/list',
        icon: I(<><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></>) },
      { label: 'Leads',         to: '/lead/list',
        icon: I(<><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/></>) },
      { label: 'Tasks',         to: '/tasks/list',
        icon: I(<><path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2"/><rect x="9" y="3" width="6" height="4" rx="1"/><polyline points="9 12 11 14 15 10"/></>) },
      { label: 'Opportunities', to: '/opportunity/list',
        icon: I(<><line x1="9" y1="18" x2="15" y2="18"/><line x1="10" y1="22" x2="14" y2="22"/><path d="M15.09 14c.18-.98.65-1.74 1.41-2.5A4.65 4.65 0 0 0 18 8 6 6 0 0 0 6 8c0 1 .23 2.23 1.5 3.5A4.61 4.61 0 0 1 9 14"/></>) },
      { label: 'Workflows',     to: '/workflow/list',
        icon: I(<><line x1="6" y1="3" x2="6" y2="15"/><circle cx="18" cy="6" r="3"/><circle cx="6" cy="18" r="3"/><path d="M18 9a9 9 0 0 1-9 9"/></>) },
      { label: 'Customers',     to: '/customer/list',
        icon: I(<><rect x="4" y="2" width="16" height="20" rx="2"/><path d="M9 22V12h6v10"/><path d="M8 7h.01"/><path d="M12 7h.01"/><path d="M16 7h.01"/><path d="M8 11h.01"/><path d="M12 11h.01"/><path d="M16 11h.01"/></>) },
      {
        label: 'Sales',
        subId: 'lead-sales',
        icon: I(<><line x1="12" y1="20" x2="12" y2="10"/><line x1="18" y1="20" x2="18" y2="4"/><line x1="6" y1="20" x2="6" y2="16"/></>),
        sub: [
          { label: 'Email Templates',   to: '/lead/email-template/list',
            icon: I(<><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></>) },
          { label: 'Sales Teams',       to: '/lead/sales-team/list',
            icon: I(<><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></>) },
          { label: 'Sales Regions',     to: '/lead/sales-region/list',
            icon: I(<><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></>) },
          { label: 'Sales Targets',     to: '/lead/sales-target/list',
            icon: I(<><circle cx="12" cy="12" r="10"/><line x1="22" y1="12" x2="18" y2="12"/><line x1="6" y1="12" x2="2" y2="12"/><line x1="12" y1="6" x2="12" y2="2"/><line x1="12" y1="22" x2="12" y2="18"/></>) },
          { label: 'Sales Performance', to: '/lead/sales-performance/list',
            icon: I(<><circle cx="12" cy="8" r="6"/><path d="M15.477 12.89L17 22l-5-3-5 3 1.523-9.11"/></>) },
        ],
      },
    ],
  },
  {
    id: 'customer',
    label: 'Customer Management',
    icon: S(<><circle cx="12" cy="12" r="10"/><path d="M12 8a3 3 0 1 0 0 6 3 3 0 0 0 0-6z"/><path d="M6 20a6 6 0 0 1 12 0"/></>),
    items: [
      { label: 'Interactions',   to: '/customer/interactions/list',
        icon: I(<><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></>) },
      { label: 'Notes',          to: '/customer/note/list',
        icon: I(<><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></>) },
      { label: 'Activities',     to: '/customer/activity/list',
        icon: I(<><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></>) },
      { label: 'Activity Types', to: '/customer/activity-type/list',
        icon: I(<><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></>) },
      { label: 'Comm. Logs',     to: '/customer/communication-log/list',
        icon: I(<><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.62 1h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.59a16 16 0 0 0 6.29 6.29l.95-.95a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></>) },
      { label: 'Documents',      to: '/customer/document/list',
        icon: I(<><path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"/></>) },
      { label: 'Reminders',      to: '/customer/reminder/list',
        icon: I(<><circle cx="12" cy="13" r="8"/><path d="M12 9v4l2 2"/><path d="M5 3L2 6"/><path d="M22 6l-3-3"/></>) },
      { label: 'Sales Stages',   to: '/customer/sales-stage/list',
        icon: I(<><polygon points="12 2 2 7 12 12 22 7 12 2"/><polyline points="2 17 12 22 22 17"/><polyline points="2 12 12 17 22 12"/></>) },
      { label: 'Sales Status',   to: '/customer/sales-status/list',
        icon: I(<><rect x="1" y="5" width="22" height="14" rx="7" ry="7"/><circle cx="16" cy="12" r="3"/></>) },
      { label: 'Forecasts',      to: '/customer/sales-forecast/list',
        icon: I(<><path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z"/></>) },
      { label: 'Webhooks',       to: '/customer/webhook-config/list',
        icon: I(<><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/></>) },
      {
        label: 'Audit Logs',
        subId: 'audit',
        icon: I(<><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/></>),
        sub: [
          { label: 'Async Events',     to: '/customer/async-event-log/list',
            icon: I(<><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></>) },
          { label: 'Gateway Messages', to: '/customer/gateway-message-log/list',
            icon: I(<><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></>) },
          { label: 'Sync Logs',        to: '/customer/sync-log/list',
            icon: I(<><polyline points="23 4 23 10 17 10"/><polyline points="1 20 1 14 7 14"/><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/></>) },
          { label: 'Change Logs',      to: '/customer/change-log/list',
            icon: I(<><circle cx="12" cy="12" r="4"/><line x1="1.05" y1="12" x2="7" y2="12"/><line x1="17.01" y1="12" x2="22.96" y2="12"/></>) },
        ],
      },
    ],
  },
  {
    id: 'opportunity',
    label: 'Opportunity Management',
    icon: S(<><path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6"/><path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18"/><path d="M4 22h16"/><path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22"/><path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22"/><path d="M6 4h12v8a6 6 0 0 1-12 0z"/></>),
    items: [
      { label: 'Stages',     to: '/opportunity/stage/list',
        icon: I(<><polygon points="12 2 2 7 12 12 22 7 12 2"/><polyline points="2 17 12 22 22 17"/><polyline points="2 12 12 17 22 12"/></>) },
      { label: 'Activities', to: '/opportunity/activity/list',
        icon: I(<><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/><path d="m9 16 2 2 4-4"/></>) },
      { label: 'Documents',  to: '/opportunity/document/list',
        icon: I(<><path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"/></>) },
      { label: 'Follow-ups', to: '/opportunity/follow-up/list',
        icon: I(<><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></>) },
      { label: 'Notes',      to: '/opportunity/note/list',
        icon: I(<><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></>) },
      { label: 'Comments',   to: '/opportunity/comment/list',
        icon: I(<><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/></>) },
      { label: 'Tasks',      to: '/opportunity/task/list',
        icon: I(<><polyline points="9 11 12 14 22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/></>) },
      { label: 'Events',     to: '/opportunity/event/list',
        icon: I(<><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></>) },
      { label: 'Meetings',   to: '/opportunity/meeting/list',
        icon: I(<><polygon points="23 7 16 12 23 17 23 7"/><rect x="1" y="5" width="15" height="14" rx="2" ry="2"/></>) },
      { label: 'Calls',      to: '/opportunity/call/list',
        icon: I(<><path d="M15.05 5A5 5 0 0 1 19 8.95M15.05 1A9 9 0 0 1 23 8.94m-1 7.98v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.37 2 2 0 0 1 3.6 1h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 8.5a16 16 0 0 0 5.91 5.91l.87-.87a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/></>) },
      {
        label: 'Lookups',
        subId: 'opp-lookups',
        icon: I(<><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></>),
        sub: [
          { label: 'Sources',        to: '/opportunity/source/list',
            icon: I(<><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></>) },
          { label: 'Priorities',     to: '/opportunity/priority/list',
            icon: I(<><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></>) },
          { label: 'Statuses',       to: '/opportunity/status/list',
            icon: I(<><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></>) },
          { label: 'Types',          to: '/opportunity/type/list',
            icon: I(<><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M3 9h18"/><path d="M9 21V9"/></>) },
          { label: 'Categories',     to: '/opportunity/category/list',
            icon: I(<><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/></>) },
          { label: 'Sub-Categories', to: '/opportunity/subcategory/list',
            icon: I(<><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/><line x1="12" y1="11" x2="12" y2="17"/><line x1="9" y1="14" x2="15" y2="14"/></>) },
          { label: 'Tags',           to: '/opportunity/tag/list',
            icon: I(<><line x1="4" y1="9" x2="20" y2="9"/><line x1="4" y1="15" x2="20" y2="15"/><line x1="10" y1="3" x2="8" y2="21"/><line x1="16" y1="3" x2="14" y2="21"/></>) },
          { label: 'Ratings',        to: '/opportunity/rating/list',
            icon: I(<><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></>) },
        ],
      },
    ],
  },
  {
    id: 'quote',
    label: 'Quote Management',
    icon: S(<><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></>),
    items: [
      { label: 'Quotes',      to: '/quote/list',
        icon: I(<><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></>) },
      { label: 'Products',    to: '/quote/product/list',
        icon: I(<><line x1="16.5" y1="9.4" x2="7.5" y2="4.21"/><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></>) },
      { label: 'Statuses',    to: '/quote/status/list',
        icon: I(<><circle cx="12" cy="12" r="10"/><polyline points="9 12 11 14 15 10"/></>) },
      { label: 'Line Items',  to: '/quote/line-item/list',
        icon: I(<><line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/></>) },
      { label: 'Versions',    to: '/quote/version/list',
        icon: I(<><path d="M3 3v5h5"/><path d="M3.05 13A9 9 0 1 0 6 5.3L3 8"/><line x1="12" y1="7" x2="12" y2="12"/><line x1="15" y1="12" x2="12" y2="12"/></>) },
      { label: 'Documents',   to: '/quote/document/list',
        icon: I(<><path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"/></>) },
      { label: 'Tasks',       to: '/quote/task/list',
        icon: I(<><polyline points="9 11 12 14 22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/></>) },
      { label: 'Follow-Ups',  to: '/quote/follow-up/list',
        icon: I(<><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></>) },
      { label: 'Payments',    to: '/quote/payment/list',
        icon: I(<><rect x="1" y="4" width="22" height="16" rx="2" ry="2"/><line x1="1" y1="10" x2="23" y2="10"/></>) },
      { label: 'Approvals',   to: '/quote/approval/list',
        icon: I(<><path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3z"/><path d="M7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"/></>) },
      { label: 'Comments',    to: '/quote/comment/list',
        icon: I(<><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/></>) },
    ],
  },
  {
    id: 'marketing',
    label: 'Marketing',
    icon: S(<><path d="M3 11l18-5v12L3 14v-3z"/><path d="M11.6 16.8a3 3 0 1 1-5.8-1.6"/></>),
    items: [
      { label: 'Campaigns', to: '/marketing/campaign/list',
        icon: I(<><path d="M3 11l18-5v12L3 14v-3z"/><path d="M11.6 16.8a3 3 0 1 1-5.8-1.6"/></>) },
    ],
  },
  {
    id: 'reporting',
    label: 'Reporting & Analytics',
    icon: S(<><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></>),
    items: [
      { label: 'Analytics Overview', to: '/reporting/overview',
        icon: I(<><path d="M21.21 15.89A10 10 0 1 1 8 2.83"/><path d="M22 12A10 10 0 0 0 12 2v10z"/></>) },
      { label: 'Reports',            to: '/reporting/report/list',
        icon: I(<><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></>) },
      { label: 'Report Fields',      to: '/reporting/report-field/list',
        icon: I(<><rect x="3" y="3" width="6" height="18"/><rect x="15" y="3" width="6" height="18"/></>) },
      { label: 'Filters',            to: '/reporting/filter/list',
        icon: I(<><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/></>) },
      { label: 'Scheduled Reports',  to: '/reporting/scheduled-report/list',
        icon: I(<><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></>) },
      { label: 'Segmentations',      to: '/reporting/segmentation/list',
        icon: I(<><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></>) },
      { label: 'Analytics Data',     to: '/reporting/analytics/list',
        icon: I(<><ellipse cx="12" cy="5" rx="9" ry="3"/><path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"/><path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"/></>) },
      { label: 'Trend Analysis',     to: '/reporting/trend/list',
        icon: I(<><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/></>) },
      { label: 'Forecasts',          to: '/reporting/forecast/list',
        icon: I(<><path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z"/></>) },
    ],
  },
  {
    id: 'security',
    label: 'Security & Audit',
    icon: S(<><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></>),
    items: [
      { label: 'Audit Logs',      to: '/security/audit-log/list',
        icon: I(<><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/></>) },
      { label: 'Login Activity',  to: '/security/login-activity/list',
        icon: I(<><path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"/><polyline points="10 17 15 12 10 7"/><line x1="15" y1="12" x2="3" y2="12"/></>) },
      { label: 'Access Control',  to: '/security/access-control/list',
        icon: I(<><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></>) },
      { label: 'Data Integrity',  to: '/security/data-integrity/list',
        icon: I(<><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><polyline points="9 12 11 14 15 10"/></>) },
      { label: 'Security Alerts', to: '/security/alert/list',
        icon: I(<><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></>) },
    ],
  },
  {
    id: 'administrator',
    label: 'Administrator',
    superAdminOnly: true,
    icon: S(<><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/></>),
    items: [
      { label: 'Tenant Management', to: '/administrator/tenant/list',
        icon: I(<><rect x="4" y="2" width="16" height="20" rx="2"/><path d="M9 22V12h6v10"/><path d="M8 7h.01"/><path d="M12 7h.01"/><path d="M16 7h.01"/><path d="M8 11h.01"/><path d="M12 11h.01"/><path d="M16 11h.01"/></>) },
      { label: 'User Management',   to: '/administrator/user/list',
        icon: I(<><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><line x1="23" y1="11" x2="17" y2="11"/><line x1="20" y1="8" x2="20" y2="14"/></>) },
    ],
  },
];

const Sidebar = () => {
  const initialOpen = SECTIONS.reduce((acc, s) => ({ ...acc, [s.id]: true }), {});
  const [openSections, setOpenSections] = useState(initialOpen);
  const [openSubs, setOpenSubs] = useState({});

  const toggleSection = (id) =>
    setOpenSections(prev => ({ ...prev, [id]: !prev[id] }));

  const toggleSub = (subId) =>
    setOpenSubs(prev => ({ ...prev, [subId]: !prev[subId] }));

  const navLinkClass = ({ isActive }) =>
    `sidebar-link${isActive ? ' active' : ''}`;

  return (
    <aside className="sidebar">
      <div className="sidebar-brand">
        <img src={katibuLogo} alt="Katibu Limitless Growth" className="sidebar-brand-image" />
      </div>

      <nav className="sidebar-nav">
        <div className="sidebar-section" style={{ borderBottom: '1px solid var(--sidebar-border)', marginBottom: 4, paddingBottom: 4 }}>
          <NavLink to="/dashboard" className={navLinkClass} style={{ fontWeight: 600, fontSize: 13 }}>
            {S(<><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></>)}
            <span className="sidebar-link-text">Dashboard</span>
          </NavLink>
          <NavLink to="/sla-alerts" className={navLinkClass}>
            {S(<><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></>)}
            <span className="sidebar-link-text">SLA &amp; Alerts</span>
          </NavLink>
          <NavLink to="/notifications" className={navLinkClass}>
            {S(<><path d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></>)}
            <span className="sidebar-link-text">Notifications</span>
          </NavLink>
        </div>

        {SECTIONS.filter(s => !s.superAdminOnly || isSuperAdmin()).map(section => (
          <div className="sidebar-section" key={section.id}>
            <div className="sidebar-section-header" onClick={() => toggleSection(section.id)}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                {section.icon}
                <span className="sidebar-section-label">{section.label}</span>
              </div>
              <span className={`sidebar-chevron${openSections[section.id] ? ' open' : ''}`}>▶</span>
            </div>

            {openSections[section.id] && (
              <div className="sidebar-items">
                {section.items.map((item, i) => {
                  if (item.sub) {
                    return (
                      <div key={i}>
                        <div className="sidebar-sub-trigger" onClick={() => toggleSub(item.subId)}>
                          <span className="sidebar-sub-trigger-label">
                            {item.icon}
                            {item.label}
                          </span>
                          <span className={`sidebar-chevron${openSubs[item.subId] ? ' open' : ''}`}>▶</span>
                        </div>
                        {openSubs[item.subId] && (
                          <div className="sidebar-sub-items">
                            {item.sub.map((subItem, j) => (
                              <NavLink key={j} to={subItem.to} className={navLinkClass}>
                                {subItem.icon}
                                <span className="sidebar-link-text">{subItem.label}</span>
                              </NavLink>
                            ))}
                          </div>
                        )}
                      </div>
                    );
                  }
                  return (
                    <NavLink key={i} to={item.to} className={navLinkClass}>
                      {item.icon}
                      <span className="sidebar-link-text">{item.label}</span>
                    </NavLink>
                  );
                })}
              </div>
            )}
          </div>
        ))}
      </nav>

      <div className="sidebar-footer">
        <button
          className="sidebar-logout-btn"
          onClick={() => {
            setLogoutReason('manual'); // intentional — login must NOT restore previous page
            ['customer_management_token', 'token', 'username', 'is_superadmin'].forEach(k => localStorage.removeItem(k));
            window.location.href = '/login';
          }}
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
            <polyline points="16 17 21 12 16 7" />
            <line x1="21" y1="12" x2="9" y2="12" />
          </svg>
          <span style={{ marginLeft: 8 }}>Sign Out</span>
        </button>
        <div className="sidebar-footer-meta">v1.0 &nbsp;·&nbsp; Katibu CRM</div>
      </div>
    </aside>
  );
};

export default Sidebar;
